import React from "react";
import Languages from "./Languages/Languages";
import { Projects } from "./../";
import cv from "./../../assets/ennani_abdelmalek_cv.pdf"
import { Link } from "react-router-dom";

function Home() {
  return (
    <React.Fragment>
      <section className="text-gray-700 body-font">
        <div className="container mx-auto flex px-5 py-24 md:py-36 md:flex-row flex-col items-center">
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900 dark:text-white">
              Hi, I am Abdelmalek Ennani
              <br />
               Web developer
            </h1>
            <p className="mb-8 leading-relaxed dark:text-slate-400">
              I am <b>Abdelmalek ENNANI</b>. I'm a software engineering student,
              Immensely passionate about web development and related
              technologies, and I aim to use my skills to enhance and improve
              the lives of people.
            </p>
            <div className="flex justify-center">
              <a href={cv} download className="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
                Resume
              </a>
              <Link to="contact" className="ml-4 inline-flex text-gray-700 bg-gray-200 border-0 py-2 px-6 focus:outline-none hover:bg-gray-300 rounded text-lg">
                Get In Touch
              </Link>
            </div>
          </div>
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <img
              className="object-cover object-center rounded"
              alt="hero"
              src="https://media0.giphy.com/media/f3iwJFOVOwuy7K6FFw/giphy.gif?cid=ecf05e47lfw2v4gjip192ccswp30aqkt9bpb0a6yx72d53pi&rid=giphy.gif&ct=g"
            />
          </div>
        </div>
      </section>
      <Languages />
      <Projects />
    </React.Fragment>
  );
}

export default Home;
